import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { throttle } from '@beef/utils';
import { HandlerBase } from "./HandlerBase";
export var DragTargetHandler = /*#__PURE__*/function (_HandlerBase) {
  _inherits(DragTargetHandler, _HandlerBase);
  var _super = _createSuper(DragTargetHandler);
  function DragTargetHandler() {
    var _this;
    _classCallCheck(this, DragTargetHandler);
    for (var _len = arguments.length, _args2 = new Array(_len), _key = 0; _key < _len; _key++) {
      _args2[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args2));
    _defineProperty(_assertThisInitialized(_this), "attachHandlers", function (domNode) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this.registerHandler([domNode].concat(args), 'mousemove', _this.throttleDragOverEnter.bind(_assertThisInitialized(_this)));
      _this.registerHandler([domNode].concat(args), 'mouseleave', _this.handleDragLeave);
      _this.registerHandler([domNode].concat(args), 'mouseup', _this.handleDrop);
    });
    _defineProperty(_assertThisInitialized(_this), "throttleDragOverEnter", throttle(30, function (event, args) {
      return _this.handleDragOverEnter(event, args);
    }));
    return _this;
  }
  _createClass(DragTargetHandler, [{
    key: "handleDragOverEnter",
    value: function handleDragOverEnter(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(event) {
      event.preventDefault();
    }
  }, {
    key: "handleDragLeave",
    value: function handleDragLeave(event) {
      event.stopPropagation();
    }
  }]);
  return DragTargetHandler;
}(HandlerBase);